module.exports = __webpack_public_path__ + "img/logo-default.377344fd.png";